import { useContext } from 'react';

import { BlockedUserDetailsContext } from './blocked-user-details-provider';

function useBlockedUserDetails() {
  const context = useContext(BlockedUserDetailsContext);

  if (!context) {
    throw new Error('useBlockedUserDetails must be used within a BlockedUserDetailsProvider');
  }

  return context;
}

export { useBlockedUserDetails };
